import common from './components/common';
import components from './components/components';
import header from './components/header';
import filters from './components/filters';
import cart from './components/cart';
import productCards from './components/product-cards';
import auth from './components/auth';
import legacyCart from './legacy/cart';
import oldmain from './legacy/oldmain';
import homePage from './pages/home-page';
import checkoutPage from './pages/checkout-page'
import productDetails from './pages/product-details';

(function() {
    common();
    components();
    header();
    filters();
    cart();
    auth();
    legacyCart();
    productCards();
    homePage();
    checkoutPage();
    productDetails();
    oldmain();
})();
